import { useCallback, useEffect, useRef, useState } from 'react'

/* ============================================================
   useUnsavedChanges — PRD §8.1 CMS
   Tracks dirty state and warns on navigation/close.
   ============================================================ */

export function useUnsavedChanges() {
  const [isDirty, setIsDirty] = useState(false)
  const dirtyRef = useRef(false)

  // Keep ref in sync for the beforeunload handler
  useEffect(() => {
    dirtyRef.current = isDirty
  }, [isDirty])

  // Browser close/reload warning
  useEffect(() => {
    const handler = (e: BeforeUnloadEvent) => {
      if (!dirtyRef.current) return
      e.preventDefault()
      // Modern browsers show a generic message, this string is ignored
      e.returnValue = 'You have unsaved changes.'
    }

    window.addEventListener('beforeunload', handler)
    return () => window.removeEventListener('beforeunload', handler)
  }, [])

  const markDirty = useCallback(() => setIsDirty(true), [])
  const markClean = useCallback(() => setIsDirty(false), [])

  return { isDirty, markDirty, markClean }
}
